import { useState, useEffect } from 'react';

import { LicenseModulesInterface } from '../../Models/License/License';

import { TableContainer } from '../../Styles/CustomViews/Pages/ListComponent/customListComponentStyles';

import CustomDetailsCard from '../../CustomViews/Pages/CustomDetailsCard/CustomDetailsCard';
import CustomListComponent from '../../CustomViews/Pages/ListComponent/CustomListComponent';

export default function LicenseModules(props: LicenseModulesInterface) {
    //Variables
    let { modules, isTableOnly } = props;

    //Use States
    let [pageNum, setpageNum] = useState(1);
    let [pageSize, setpageSize] = useState(5);
    let [records, setrecords] = useState([]);
    let [InitModules, setInitModules] = useState(true);

    const tableColumns = [
        {
            accessor: 'name',
            title: (isTableOnly ? "Modules" : "Module Name"),
            sortable: true,
            textAlign: 'left',
        },
    ];

    //Event Handlers
    const initializeModules = async () => {
        const from = (pageNum - 1) * pageSize;
        const to = from + pageSize;

        setrecords(modules?.slice(from, to) ?? []);

        setInitModules(false);
    } 

    useEffect(() => {
        initializeModules();
    }, [pageNum, pageSize]);

    useEffect(() => {
        setInitModules(true);
    }, []);

    useEffect(() => {
        if(modules?.length > 0 && InitModules) {
            initializeModules();
        }
    }, [InitModules, modules]);

    //Rendering Functions
    const renderLicenseModulesTable = () => {
        return <TableContainer className="companyModulesTable">
                <CustomListComponent
                    fetching={false}
                    columns={tableColumns}
                    idAccessor={(record: any) => `companyLicenseHistory${record?.publicId}`}
                    records={records ?? []}
                    totalRecords={modules?.length ?? 0}
                    page={pageNum}
                    recordsPerPage={pageSize}
                    setPage={(p: number) => setpageNum(p)}
                    onRecordsPerPageChange={(p: number) =>{ setpageSize(p); setpageNum(1);}} />
            </TableContainer>
    }

    const renderTableOnly = () => {
        return renderLicenseModulesTable()
    }

    const renderWithCardContainer = () => {
        return <CustomDetailsCard
        title={"License Modules"} >
            {renderLicenseModulesTable()}
        </CustomDetailsCard>
    }

    return (isTableOnly ? renderTableOnly() : renderWithCardContainer())
}
